import React, { useEffect, useState } from "react";
import { Layout } from "@/components/Layout";
import { api } from "@/lib/api";
import { ToolCard } from "@/components/ToolCard";
import { PageHero } from "@/components/PageHero";
export default function Favorites() {
  const [favs, setFavs] = useState([]);
  useEffect(()=>{ api.get("/favorites").then(r => setFavs(r.data.favorites)); }, []);
  return (
    <Layout hideRightPanel>
      <PageHero
        testId="favorites-hero"
        eyebrow="My Stack"
        title={<>Your <span className="italic">favorites.</span></>}
        sub="Every tool you've hearted, in one place — your personal corner of the encyclopedia."
      />
      {favs.length === 0 ? <p className="text-[#5B6478]">No favorites yet. Heart a tool from the directory to save it here.</p> :
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">{favs.map(t => <ToolCard key={t.slug} tool={t} isFav/>)}</div>}
    </Layout>
  );
}
